import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#09090b] text-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="font-heading font-bold text-xl tracking-tight">
              G.O.A.T. ATHLETIC
            </Link>
            <p className="mt-4 text-zinc-400 max-w-sm">
              Performance gear built for young athletes who want to push harder, jump higher, and level up.
            </p>
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.instagram.com/g.o.a.t_au/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-zinc-400 hover:text-[#00ff9d] transition-colors" 
                data-testid="social-instagram"
                aria-label="Follow us on Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61560145434274" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-zinc-400 hover:text-[#00ff9d] transition-colors" 
                data-testid="social-facebook"
                aria-label="Follow us on Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider mb-4">Shop</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/shop" className="text-zinc-400 hover:text-[#00ff9d] transition-colors text-sm">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/shop?category=socks" className="text-zinc-400 hover:text-[#00ff9d] transition-colors text-sm">
                  Socks
                </Link>
              </li>
              <li>
                <Link to="/shop?category=apparel" className="text-zinc-400 hover:text-[#00ff9d] transition-colors text-sm">
                  Apparel
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider mb-4">Support</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-zinc-400 hover:text-[#00ff9d] transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <a href="mailto:admin@goatathleteapparel.com" className="text-zinc-400 hover:text-[#00ff9d] transition-colors text-sm">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-sm">
            © {new Date().getFullYear()} G.O.A.T. Athletic. All rights reserved.
          </p>
          <p className="text-zinc-500 text-sm">
            Currency: AUD
          </p>
        </div>
      </div>
    </footer>
  );
};
